import { localizeNumbers } from "../../../functions";

export interface IStepProps {
  isActive?: boolean;
  lastStep?: boolean;
  step: number;
  title: string;
  steps:number[];
}

export default function Step({ isActive, lastStep, step, title, steps }: IStepProps) {
  const isStepExist = steps.includes(step);

  return (
    <>
      <div
        className={`sm:pr-5 pl-5 ${
          !isStepExist
            ? "hidden sm:flex sm:flex-col sm:justify-center sm:items-center sm:flex-1"
            : ""
        }`}
      >
        <div className={isActive ? "circle-step active" : "circle-step"}>
          <span className="step-number">{localizeNumbers(step)}</span>
        </div>
        <h4 className="step-title">{title}</h4>
      </div>
      {lastStep ?? (
        <div className="w-1/6 align-center items-center align-middle content-center flex">
          <div className="blue-line hidden sm:block">
            <div className="text-xs leading-none p-1 text-center text-grey-darkest rounded" />
          </div>
        </div>
      )}
    </>
  );
}
